const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Arya", "Arya V", "Arya Vats"],
	},
	
	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Arya", "Arya V", "Arya Vats"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Arya", "Arya V", "Arya Vats"],
	},

	{
		page: "projects",
		description:
			'I strongly believe that making projects while learning is very important. Even if a person is a professional, projects are a reflection of their understanding and interests. So far I have developed many projects, here are some of them. You can find the rest of my builds on https://github.com/arya-vats</a>.',
		keywords: ["Arya", "Arya V", "Arya Vats"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Arya", "Arya V", "Arya Vats"],
	},
];

export default SEO;
